import "./RecentLog.css";

export const LOG_STATS = [["pts", "PTS"], ["min", "MIN"], ["reb", "REB"], ["ast", "AST"], ["fg3m", "3PM"], ["pra", "PRA"]];

export function StatFilterBar({ value, onChange }) {
  return (
    <div className="rl-filter" role="tablist" data-testid="recent-stat-filter">
      <span className="rl-filter-label">Last 10</span>
      {LOG_STATS.map(([k, label]) => (
        <button key={k} type="button" role="tab" aria-selected={value === k} data-testid={`recent-filter-${k}`}
          className={value === k ? "is-active" : ""} onClick={() => onChange(k)}>{label}</button>
      ))}
    </div>
  );
}

const dayLabel = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });

export function RecentLog({ recent, stat, pid }) {
  const games = (recent?.games || []).slice(-10);
  if (!games.length) return <div className="rl-boxes rl-empty" data-testid={`recent-log-${pid}`}>No games this season</div>;
  const avg = recent.avg?.[stat];
  return (
    <div className="rl-boxes" data-testid={`recent-log-${pid}`}>
      {games.map((g, i) => {
        const v = g[stat];
        const tone = avg == null || v === avg ? "even" : v > avg ? "up" : "down";
        const tip = `${g.home ? "vs" : "@"} ${g.opp ?? "—"} · ${dayLabel(g.date)}`;
        return <button type="button" key={`${g.date}-${i}`} className={`rl-box ${tone}`} data-tip={tip} aria-label={`${v} ${tip}`} data-testid={`recent-box-${pid}-${i}`}>{v}</button>;
      })}
    </div>
  );
}
